import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { DatadogService } from './datadog.service';

export const datadogCanActivateGuard: CanActivateFn = () => {
  const datadogService = inject(DatadogService);
  datadogService.init();
  return true;
};
